
import React from 'react';
import { connect } from 'react-redux';
import { Column } from "primereact/column";
import { Page } from "../../../components/page/Page";
import Toolbar from "../../../components/toolbar/Toolbar";
import { Card } from "primereact/card";
import { routes } from '../../../constants';
import { actions } from '../notificationOccurrence.actions';
import { actions as occurrenceTypeActions } from "../../occurrenceType/occurrenceType.actions";
import { NotificationOccurrenceForm } from "./NotificationOccurrenceForm";

const mapStateToProps = state => {
    let columnsSelectionRecords = state.crudNotificationOccurrenceState.columnsSelectionRecords;
    let occurrenceTypeFilter = state.crudNotificationOccurrenceState.occurrenceTypeFilter;
    let selectedRecords = state.crudNotificationOccurrenceState.selectedRecords;
    let currentRecord = state.crudNotificationOccurrenceState.currentRecord;
    const lookupOccurrenceType = {
        records: state.crudOccurrenceTypeState.records,
        columns: state.crudNotificationOccurrenceState.lookupOccurrenceType.visible ? (
            state.crudOccurrenceTypeState.columns.filter((col) => col.field === "oid" || col.field === "description").map((col) => <Column key={col.field} {...col} />)
        ) : (
            []
        ),
        first: state.crudOccurrenceTypeState.index,
        rows: state.crudOccurrenceTypeState.max,
        totalRecords: state.crudOccurrenceTypeState.count,
        sortField: state.crudOccurrenceTypeState.sortField,
        order: state.crudOccurrenceTypeState.sortOrder,
        visible: state.crudNotificationOccurrenceState.lookupOccurrenceType.visible,
        editDisabled: true,
        modal: false,
        rowsPerPageOptions: [20, 50, 100],
        paginator: true,
        booleanFilter: state.crudOccurrenceTypeState.booleanFilter,
        booleanTypes: [
            { label: 'Todos', value: '' },
            { label: 'Sistema', value: "SYSTEM" },
            { label: 'Empresa', value: 'COMPANY' }
        ],
    }
    return {
        currentRecord,
        lookupOccurrenceType,
        occurrenceTypeFilter,
        selectedRecords,
        columnsSelectionRecords
    }

}

const mapDispatchToProps = dispatch => {

    return {
        setField: (field, value) => dispatch(actions.setField(field, value)),

        changeHandler: event => {
            const target = event.target;
            const field = target.name;
            let value = target.value;
            dispatch(actions.removeErrors([{ field }]));
            dispatch(actions.setField(field, value));
        },

        saveHandler: event => {
            dispatch(actions.save());
        },

        removeHandler: event => {
            dispatch(actions.remove());
        },

        newHandler: event => {
            dispatch(actions.makeNew());
        },

        loadById: oid => dispatch(actions.loadById(oid)),

        // lookupOccurrenceType start
        lookupOccurrenceTypeSetVisible: (visible) => dispatch(actions.setlookupOccurrenceTypeVisible(visible)),
        lookupOccurrenceTypePaginate: (paginationParams) => dispatch(occurrenceTypeActions.paginate(paginationParams)),
        lookupOccurrenceTypeSortOrder: (sortParams) => dispatch(occurrenceTypeActions.paginate(sortParams)),
        lookupOccurrenceTypeApplyFilter: (filterParams) => {
            dispatch(occurrenceTypeActions.setType(null));
            dispatch(occurrenceTypeActions.applyFilter(filterParams));
        },
        lookupOccurrenceTypeLoad: () => dispatch(occurrenceTypeActions.load()),
        setOccurrenceTypeFilter: (occurrenceType) => {
            dispatch(actions.setFieldOccurrenceTypeFilter("occurrenceTypeFilter", occurrenceType));
        },
        // lookupOccurrenceType end
        setSelectedRecords: (selectedRecords) => dispatch(actions.setSelectedRecords(selectedRecords)),
    }
}


class NotificationOccurrenceFormPageContainer extends React.Component {
    constructor(props) {
        super(props);
        actions.afterSave = ({ oid }) => {
            this.props.history.replace(`${routes.PATH_NOTIFICATION_OCCURRENCE}/${oid}`);
        };
        actions.afterNew = () => {
            this.props.history.replace(`${routes.PATH_NOTIFICATION_OCCURRENCE}/novo`);
        };
        actions.afterRemove = () => {
            this.props.history.replace(`${routes.PATH_NOTIFICATION_OCCURRENCE}`);
        };
    }

    componentDidMount() {
        const oid = this.props.match.params.id;
        if (oid && parseInt(oid)) {
            this.props.loadById(oid);
        } else {
            this.props.newHandler();
        }
    }

    searchHandler = () => {
        this.props.setSelectedRecords([]);
        this.props.history.push(`${routes.PATH_NOTIFICATION_OCCURRENCE}`)
    }

    setSelectedRecordsHandler = (e) => {
        this.props.setSelectedRecords(e.originalEvent.value);
    }
    useWhatsAppNotificationHandler = (e) => {
        this.props.setField("useWhatsAppNotification", e);
    }

    useEmailNotificationHandler = (e) => {
        this.props.setField("useEmailNotification", e);
    }

    removeSelectionOccurrenceHandler = (e) => {
        if (this.props.selectedRecords.length > 0) {
            let selectedRecords = this.props.selectedRecords.filter((record) => record.oid !== e.oid);
            this.props.setSelectedRecords(selectedRecords);
        } else if (this.props.currentRecord.notificationOccurrences.length > 0) {
            let notificationOccurrences = this.props.currentRecord.notificationOccurrences.filter((record) => record.oid !== e.oid);
            this.props.setSelectedRecords(notificationOccurrences);
        } else {
            return;
        }
    }

    // lookup occurrenceType
    lookupOccurrenceTypeOnPage = (e) => {
        this.props.lookupOccurrenceTypePaginate({
            max: e.rows,
            index: e.first,
        });
    };
    lookupOccurrenceTypeOnSort = (e) => {
        this.props.lookupOccurrenceTypeSortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField,
        });
    };
    lookupOccurrenceTypeOnFilter = (e) => {
        const filters = [];
        const keys = Object.keys(e.filters) || [];
        keys.forEach((key) => {
            filters.push({
                campo: key,
                valor: e.filters[key].value,
                tipoFiltro: "CONTEM",
            });
        });
        this.props.lookupOccurrenceTypeApplyFilter(filters);
    };
    lookupOccurrenceTypeOnClick = (e) => {
        this.props.lookupOccurrenceTypeApplyFilter([]);
        this.props.lookupOccurrenceTypeLoad();
        this.props.lookupOccurrenceTypeSetVisible(true);
    };
    lookupOccurrenceTypeOnHide = (e) => {
        this.props.lookupOccurrenceTypeApplyFilter([]);
        this.props.lookupOccurrenceTypeSetVisible(false);
    };
    lookupOccurrenceTypeOnConfirm = (e) => {
        this.props.lookupOccurrenceTypeApplyFilter([]);
        this.props.setOccurrenceTypeFilter(e.selection);
        this.props.lookupOccurrenceTypeSetVisible(false);
    };
    lookupOccurrenceTypeOnCancel = (e) => {
        this.props.lookupOccurrenceTypeApplyFilter([]);
        this.props.setOccurrenceTypeFilter(null);
        this.props.lookupOccurrenceTypeSetVisible(false);
    };

    lookupOccurrenceTypeOnComplete = (e) => {
        // this.props.lookupOccurrenceTypeApplyFilter([]);
    };

    lookupOccurrenceTypeOnInputFilter = (e) => {
        const value = e.value;
        if (typeof value === "string") {
            const filters = [
                {
                    campo: "description",
                    valor: e.value,
                    tipoFiltro: "CONTEM",
                },
            ];
            this.props.setOccurrenceTypeFilter({ description: value });
            this.props.lookupOccurrenceTypeApplyFilter(filters);
        } else {
            this.props.setOccurrenceTypeFilter(value);
        }
    };

    templateActions = (rowData) => {
        if (rowData) {
            return (
                <button
                    className="lognex-btn-danger"
                    style={{
                        width: "30px",
                        cursor: "pointer",
                        height: "30px",
                        margin: "auto",
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.removeSelectionOccurrenceHandler(rowData)
                    }}
                >
                    <i className="pi pi-trash"></i>
                </button>
            );
        }
    }

    render() {
        const title = `Nova configuração de notificação`;
        const header = (
            <div>
                <h1>{title}</h1>
                <hr className="lxSplitter" ></hr>
                <div>
                    <Toolbar
                        onSave={this.props.saveHandler} saveButtonStyle='highlighted'
                        onRemove={this.props.removeHandler} removeButtonStyle='danger'
                        onNew={this.props.newHandler}
                        onSearch={this.searchHandler}>
                    </Toolbar>
                </div>
            </div>
        );

        const columnsSelectionRecords = this.props.columnsSelectionRecords.map(col => {
            if (col.field === 'description') {
                return (<Column {...col} key={col.field} style={{ width: '50%' }} />);
            }
            if (col.field === 'action') {
                return (<Column {...col} key={col.field} body={this.templateActions} style={{ width: '10%' }} />);
            }

            return (<Column {...col} key={col.field} />)
        })

        let content = (
            <>
                <NotificationOccurrenceForm
                    changeHandler={this.props.changeHandler}
                    columnsSelectRecords={columnsSelectionRecords}
                    record={this.props.currentRecord}
                    lookupOccurrenceType={this.props.lookupOccurrenceType}
                    lookupOccurrenceTypeOnComplete={this.lookupOccurrenceTypeOnComplete}
                    lookupOccurrenceTypeOnInputFilter={this.lookupOccurrenceTypeOnInputFilter}
                    lookupOccurrenceTypeOnEdit={this.lookupOccurrenceTypeOnEdit}
                    lookupOccurrenceTypeOnClick={this.lookupOccurrenceTypeOnClick}
                    lookupOccurrenceTypeOnConfirm={this.lookupOccurrenceTypeOnConfirm}
                    lookupOccurrenceTypeOnCancel={this.lookupOccurrenceTypeOnCancel}
                    lookupOccurrenceTypeOnPage={this.lookupOccurrenceTypeOnPage}
                    lookupOccurrenceTypeOnFilter={this.lookupOccurrenceTypeOnFilter}
                    lookupOccurrenceTypeOnSort={this.lookupOccurrenceTypeOnSort}
                    lookupOccurrenceTypeOnHide={this.lookupOccurrenceTypeOnHide}
                    onSelectionChange={this.setSelectedRecordsHandler}
                    onUseWhatsAppNotification={this.useWhatsAppNotificationHandler}
                    onUseEmailNotification={this.useEmailNotificationHandler}
                    selectedRecords={this.props.selectedRecords}
                    occurrenceTypeFilter={this.props.occurrenceTypeFilter}
                />
            </>
        )
        return (<Page header={header} content={content} />)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationOccurrenceFormPageContainer);



